import React from "react";

export default function BooleanDisplayField({ value }) {
  if (value === "true") return "Yes";
  if (value === "false") return "No";
  return null;
}
